export default function api (){

    return   "https://back-rispostini.risposta42.it" 
   // return "https://int-risp.onrender.com"
}